import React, { useState, useEffect, useRef } from 'react';
import './Slider.css';
import firstSliderImage from '../../assets/images/BannerImages/1.webp';
import secondSliderImage from '../../assets/images/BannerImages/2.webp';
import thirdSliderImage from '../../assets/images/BannerImages/3.webp';
import fourthSliderImage from '../../assets/images/BannerImages/4.webp';

import mobileFirstSliderImage from '../../assets/images/BannerImages/1.webp';
import mobileSecondSliderImage from '../../assets/images/BannerImages/2.webp';
import mobileThirdSliderImage from '../../assets/images/BannerImages/3.webp';
import mobileFourthSliderImage from '../../assets/images/BannerImages/4.webp';

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const preloadedImagesRef = useRef([]);

  const slides = [
    {
      id: 1,
      title: "DIWALI DECORATION SERVICES",
      subtitle: "Illuminate Your Celebrations",
      description: "Transform your home with our stunning Diwali decorations and create magical memories",
      backgroundImage: firstSliderImage,
      mobileImage: mobileFirstSliderImage, // Can be set to a different mobile image
      textPosition: "center-left",
      textColor: "white",
    },
    {
      id: 2,
      title: "India's No.1 Decoration Website",
      subtitle: "Trusted by Thousands Across India",
      description: "Professional event decoration services for weddings, parties, and special occasions",
      backgroundImage: secondSliderImage,
      mobileImage: mobileSecondSliderImage, // Can be set to a different mobile image
      textPosition: "center-left",
      textColor: "white",
    },
    {
      id: 3,
      title: "Professional Wedding Car Decoration",
      subtitle: "Make Your Special Day Unforgettable",
      description: "Beautiful wedding car decorations that will make your grand entrance truly spectacular",
      backgroundImage: thirdSliderImage,
      mobileImage: mobileThirdSliderImage, // Can be set to a different mobile image
      textPosition: "center-left",
      textColor: "white",
    },
    {
      id: 4,
      title: "Wedding Collection",
      subtitle: "From Haldi to Honeymoon",
      description: "Complete wedding decoration services for every ceremony and celebration",
      backgroundImage: fourthSliderImage,
      mobileImage: mobileFourthSliderImage, // Can be set to a different mobile image
      textPosition: "center-left",
      textColor: "white",
    }
  ];

  // Handle window resize for mobile detection
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-advance slider every 6 seconds (pauses on hover)
  useEffect(() => {
    if (!isHovered && !isTransitioning) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [slides.length, isHovered, isTransitioning]);

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    setTimeout(() => setIsTransitioning(false), 800);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    setTimeout(() => setIsTransitioning(false), 800);
  };

  const goToSlide = (index) => {
    if (isTransitioning || index === currentSlide) return;
    setIsTransitioning(true);
    setCurrentSlide(index);
    setTimeout(() => setIsTransitioning(false), 800);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === 'ArrowLeft') prevSlide();
      if (e.key === 'ArrowRight') nextSlide();
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [isTransitioning]);

  // Preload slider images (desktop + mobile) to reduce perceived loading time
  useEffect(() => {
    if (preloadedImagesRef.current.length) return;

    const preloadList = [];
    slides.forEach((slide) => {
      [slide.backgroundImage, slide.mobileImage]
        .filter(Boolean)
        .forEach((src) => {
          const image = new Image();
          image.src = src;
          preloadList.push(image);
        });
    });

    preloadedImagesRef.current = preloadList;

    return () => {
      preloadedImagesRef.current.forEach((image) => {
        image.src = '';
      });
      preloadedImagesRef.current = [];
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div 
      className="slider-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="slider-wrapper">
        <div 
          className="slider-track"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide, index) => {
            // Use mobile image on mobile devices, desktop image otherwise
            const imageToUse = isMobile && slide.mobileImage ? slide.mobileImage : slide.backgroundImage;
            
            return (
            <div 
              key={slide.id} 
              className="slider-slide"
            >
              <img 
                src={imageToUse} 
                alt={slide.title || `Slide ${index + 1}`}
                className="slider-image"
                loading={index === 0 ? "eager" : "lazy"}
                decoding="async"
                fetchPriority={index === 0 ? "high" : "auto"}
              />
              {/* <div 
                className="slide-overlay"
                style={{ backgroundColor: slide.overlay }}
              ></div> */}
              {/* <div className={`slide-content ${slide.textPosition} ${index === currentSlide ? 'active' : ''}`} style={{ color: slide.textColor }}>
                <div className="slide-text-wrapper">
                  <h2 className="slide-title">{slide.title}</h2>
                  {slide.subtitle && <p className="slide-subtitle">{slide.subtitle}</p>}
                  {slide.description && <p className="slide-description">{slide.description}</p>}
                </div>
              </div> */}
            </div>
          );
          })}
        </div>
        
        {/* Navigation Arrows */}
        <button 
          className={`slider-nav slider-nav-prev ${isHovered ? 'visible' : ''}`} 
          onClick={prevSlide}
          disabled={isTransitioning}
        >
          <span className="nav-icon">‹</span>
        </button>
        <button 
          className={`slider-nav slider-nav-next ${isHovered ? 'visible' : ''}`} 
          onClick={nextSlide}
          disabled={isTransitioning}
        >
          <span className="nav-icon">›</span>
        </button>
        
        {/* Progress Bar */}
        <div className="slider-progress">
          <div 
            className="progress-bar"
            style={{ width: `${((currentSlide + 1) / slides.length) * 100}%` }}
          ></div>
        </div>
        
        {/* Dots Indicator */}
        <div className="slider-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`slider-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              disabled={isTransitioning}
            />
          ))}
        </div>

        {/* Slide Counter */}
        {/* <div className="slide-counter">
          <span className="current-slide">{currentSlide + 1}</span>
          <span className="total-slides">/{slides.length}</span>
        </div> */}
      </div>
    </div>
  );
};

export default Slider;
